/**
 * Load framework modules and modules that depend on them.
 */
require('./bootstrap')

// Load modules independent of the framework.

// FileSaver
// https://github.com/eligrey/FileSaver.js#readme
import 'file-saver'

// NoUiSlider
// https://refreshless.com/nouislider/download/
// @TODO import this where it's used.
import noUiSlider from 'nouislider'
window.noUiSlider = noUiSlider

// Leaflet
// https://leafletjs.com/download.html
// https://github.com/CliffCloud/Leaflet.EasyButton
// @TODO import only the modules needed and where used.
import L from 'leaflet'
window.L = L
import 'leaflet-draw'
import 'leaflet-easybutton'

import { initialize } from './common'
initialize()

// Localization is used throughout the app and should be loaded ASAP.
import { Translator } from './components/localization/translation'
const translator = new Translator()

// Expose some helper functions to make translation calls shorter.
window.__ = translator.trans.bind(translator)
window.trans = translator.trans.bind(translator)
window.trans_choice = translator.trans_choice.bind(translator)

import { SelectLocalization } from './components/localization/select'
import { getDatatablesLanguage } from './components/localization/datatables'
$(() => {
  const selectLocalization = new SelectLocalization()
  selectLocalization.onLoad()
  translator.onLoad()

  window.locale = selectLocalization.code.toLowerCase()
  window.datatablesLanguage = getDatatablesLanguage()

  // Set locale for dependencies
  $.datetimepicker.setLocale(selectLocalization.language);
  if (window.locale !== 'en-us' && typeof CfgManager !== 'undefined') {
    CfgManager.usesMetric = true
  }
})

import { NotificationsModal } from './components/notifications/notifications-modal'
$(() => {
  const notificationsModal = new NotificationsModal()
  notificationsModal.onLoad()
})

import { ScheduleModal } from './components/schedule/schedule-modal'
$(() => {
  const scheduleModal = new ScheduleModal()
  scheduleModal.onLoad()
})

/**
 * Load the aggregated alerts module when on the alerts page.
 */
$(async () => {
  if ($('#alert-aggregate-table').length > 0) {
    const { AlertsAggregrated } = await import('./components/alerts-aggregated/alerts-aggregated')
    // const { AlertFaker } = await import ('./components/alerts-aggregated/alert-faker')
    const alertsAggregated = new AlertsAggregrated('alert-aggregate-table')
    // const alertFaker = new AlertFaker()
    // alertsAggregated.setAlerts(alertFaker.getAlerts(50))
    alertsAggregated.setAlerts([])
    alertsAggregated.initialize()
  }
})

/**
 * Load the configuration modal scripts.
 */
 $(async () => {
   if ($('#ID_CFG_MODAL').length > 0) {
     const { ConfigurationModal } = await import('./components/configuration/configuration-modal')
     const configurationModal = new ConfigurationModal()
     configurationModal.onLoad()
   }
 })

/**
 * Load the reset password module when on the reset password page.
 */
$(async () => {
  if ($('#get-reset-code-button').length > 0) {
    const { ResetPassword } = await import('./components/auth/reset-password')
    const resetPassword = new ResetPassword()
    resetPassword.listenToGetResetCode()
    resetPassword.listenToSetNewPassword()
  }
})

/**
 * Load the share manage module when on the share my ICTs page.
 */
$(async () => {
  if ($('#shared-icts-table').length > 0) {
    const { ShareManage } = await import('./components/share-manage/share-manage')
    const shareManage = new ShareManage()
    shareManage.onLoad()
  }
})
